import _ from 'lodash'
import { Module } from 'vuex'

import { RootState } from '../../types'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import { initialSearchContactLensState, SearchContactLensState } from './types'

export const searchContactLens: Module<SearchContactLensState, RootState> =  {
  namespaced: true,
  state: _.cloneDeep(initialSearchContactLensState),
  actions,
  getters,
  mutations,
}
